export const SIDEBAR_FEATURE_LABELS: Record<string, string> = {
  can_view_business_dashboard: 'Dashboard',
  can_view_organization_tree: 'Organization > Tree',
  can_view_tenant_directory: 'Organization > Tenants',
  can_view_vendor_directory: 'Organization > Clients',
  can_view_supplier_directory: 'Organization > Suppliers',
  can_view_retail_customer_directory: 'Organization > Retail customers',
  can_view_business_customer_directory: 'Organization > Business customers',
  can_view_client_directory: 'Organization > Clients',
  can_view_branch_directory: 'Organization > Branches',
  can_view_user_directory: 'Organization > Users',
  can_view_role_directory: 'Role > Role assignments',
  can_access_organization_verticals: 'Organization > Verticals',
  can_access_user_documents: 'User > Documents',
  can_access_branch_service_products: 'Services > Products',
  can_access_service_categories: 'Services > Categories',
  can_access_devices: 'Services > Devices',
  can_access_master_categories: 'Services > Master categories',
  can_access_service_pos: 'Services > POS',
  can_access_service_orders: 'Products & Bookings > Bookings',
  can_access_service_offers: 'Services > Offers',
  can_access_resource_planner: 'Services > Resource Planner',
  can_access_membership: 'Services > Membership',
  can_view_customer_directory: 'Services > Customers',
  can_access_job_management: 'Job Management',
  can_access_jobs: 'Job Management > Jobs',
  can_access_events: 'Event Management > Events',
  can_access_event_days: 'Event Management > Event Days',
  can_access_job_categories: 'Job Management > Job Category',
  can_access_job_audit: 'Job Management > Audit',
  can_access_job_customers: 'Job Management > Customers',
  can_access_workers: 'Job Management > Workers',
  can_access_vehicles: 'Job Management > Vehicles',
  can_access_job_locations: 'Job Management > Locations',
  can_access_assignments: 'Job Management > Assignments',
  can_access_worker_skills: 'Job Management > Worker Skills',
  can_access_worker_hotline: 'Job Management > Workers > Hotline',
  can_access_worker_tracking: 'Job Management > Workers > Worker Tracking',
  can_access_teams: 'Job Management > Teams',
  can_access_workdays: 'Job Management > Work Days',
  can_access_group_workday_access: 'Job Management > Group WorkDay Access',
  can_access_job_configuration: 'Job Management > Configuration',
  can_access_job_workflows: 'Job Management > Workflows',
  can_access_finance: 'Finance',
  can_access_finance_reports: 'Finance > Reports',
  can_access_monthwise_reports: 'Finance > Reports > Monthwise',
  can_access_company_reports: 'Finance > Reports > Company',
  can_access_worker_reports: 'Finance > Reports > Worker',
  can_access_client_reports: 'Finance > Reports > Client',
  can_access_expenses: 'Finance > Expenses',
  can_access_invoice_management: 'Finance > Invoices',
  can_access_invoices: 'Finance > Invoices > Customer',
  can_access_invoice_payments: 'Finance > Invoices > Customer > Payments',
  can_access_inventory: 'Finance > Inventory',
  can_access_worker_invoices: 'Finance > Invoices > Worker',
  can_access_worker_payouts: 'Finance > Invoices > Worker > Payments',
  can_access_company_payments: 'Finance > Invoices > Settlements > Worker cash',
  can_access_inter_company_settlement: 'Finance > Invoices > Settlements',
  can_manage_in_apps: 'Apps > In-app settings',
  can_access_communication: 'Communication',
  can_use_maps: 'Job > Map usage',
  can_manage_credentials: 'Settings > Credentials',
  can_manage_templates: 'Settings > Templates',
  can_manage_communication_chat: 'Communication > Chat',
  can_manage_communication_email: 'Communication > Email',
  can_manage_communication_sms: 'Communication > SMS',
  can_manage_communication_whatsapp: 'Communication > WhatsApp',
  can_manage_communication_slack: 'Communication > Slack',
  can_manage_roles: 'Role > Manage Roles',
  can_manage_features: 'Admin > Manage Features',
  can_access_worker_attendance: 'Job Management > Workers > Attendance',
  can_access_expense_categories: 'Finance > Expenses > Categories',
  can_access_expense_payments: 'Finance > Expenses > Payments',
  can_manage_membership_payments: 'Services > Membership > Payments',
  can_manage_membership_plans: 'Services > Membership > Plans',
  can_manage_membership_subscriptions: 'Services > Membership > Subscriptions',
}

export const getSidebarFeatureLabel = (sidebarKey?: string | null) => {
  if (!sidebarKey) {
    return null
  }

  return SIDEBAR_FEATURE_LABELS[sidebarKey] ?? sidebarKey
}
